import { Message } from "element-ui";
const request = require("../request-utils.js");
import { callFeign, callFeignV1 } from "../api-utils/api-callFeign.js";

/**
 * 创建退款申请
 */
const createSellbackOrder = (sellbackInfo) => {
  return new Promise((resolve, reject) => {
    request.default.jackyunPost(
      {
        method: "jmall.trade.createsellbackorder",
        jsonStr: JSON.stringify(sellbackInfo),
      },
      (res) => {
        let data = res.code == 200 && res.result.data;
        let sellbackTypeName = sellbackInfo.sellbackType == 1 ? "退款" : "退货";
        if (data) {
          Message.success(`${sellbackTypeName}申请创建成功`);
        } else {
          console.log("创建退款申请失败：", res);
          Message.error(res.msg || `${sellbackTypeName}申请创建失败`);
        }
        resolve(data);
      }
    );
  });
};

/**
 * 获取已经申请了退款的商品列表
 */
const getRefundedGoodsList = (jackyunTradeNo) => {
  return new Promise((resolve, reject) => {
    request.default.jackyunPost(
      {
        method: "jmall.trade.getrefundedgoodslistbyjackyuntradeno",
        jsonStr: JSON.stringify({
          jackyunTradeNo,
        }),
      },
      (res) => {
        let data = [];
        if (res.code == 200) {
          data = res.result.data;
        } else {
          console.log("获取已经申请了退款的商品列表失败：", res);
        }
        resolve(data);
      }
    );
  });
};

/**
 * 根据吉客云销售单号获取退款单状态
 */
const getRefundStatusByJackyunTradeNo = (jackyunTradeNoList) => {
  return new Promise((resolve, reject) => {
    request.default.jackyunPost(
      {
        method: "jmall.trade.getrefundstatusbyjackyuntradeno",
        jsonStr: JSON.stringify({
          jackyunTradeNoList,
        }),
      },
      (res) => {
        let data = [];
        if (res.code == 200) {
          data = res.result.data || [];
        } else {
          console.log("获取退款单状态失败：", res);
        }
        resolve(data);
      }
    );
  });
};

/**
 * 根据吉客云销售单号获取退款单状态
 */
const getReshipmentGoods = (tradeNo) => {
  return new Promise((resolve, reject) => {
    callFeignV1("ass-business.exchange.getexchangegoodsbytradeno", {
      jsonStr: JSON.stringify({
        bizContent: {
          tradeNo,
          bModifyPage: false,
          isUseCache: false,
          needDataMask: false,
          useCache: false,
        },
      }),
    }).then((res) => {
      let data = [];
      if (res && res.code == 200) {
        let temp = JSON.parse((res && res.result && res.result.data) || "{}");

        data = temp.items || [];
      }
      resolve(data);
    });
  });
};

/**
 * 获取退货地址
 */
const getSellBackAddress = (channelId, warehouseId) => {
  return new Promise((resolve, reject) => {
    callFeignV1("assbusiness.open.getreturnaddressinfo", {
      jsonStr: JSON.stringify({
        bizContent: {
          itemList: [
            {
              shopId: channelId,
              warehouseId,
            },
          ],
        },
      }),
    }).then((res) => {
      let data = [];
      if (res && res.code == 200) {
        let temp = JSON.parse((res.result && res.result.data) || "{}");
        data = temp.items || [];
      }
      let sellerAddressInfo = (data[0] && data[0].sellerAddressInfo) || {};
      resolve(sellerAddressInfo);
    });
  });
};

/**
 * 获取发货仓库地址
 */
const getSellerWarehouseAddress = (warehouseId) => {
  return new Promise((resolve, reject) => {
    callFeignV1("erp.warehouse.get", {
      warehouseId,
    }).then((res) => {
      let data = {};
      if (res && res.code == 200) {
        data = res.result.data || {};
      }
      resolve(data);
    });
  });
};

/**
 * 批量查询卡券是否能退
 */
const getCouponCanrefund = (ticketIds) => {
  return new Promise((resolve, reject) => {
    request.default.jackyunPost(
      {
        method: "jmall.coupon.checkcanrefund",
        jsonStr: JSON.stringify({
          ticketIds,
        }),
      },
      (res) => {
        let data = [];
        if (res.code == 200) {
          data = res.result.data.canNotTicketIdList || [];
        }
        resolve(data);
      }
    );
  });
};

export default {
  createSellbackOrder,
  getRefundedGoodsList,
  getRefundStatusByJackyunTradeNo,
  getReshipmentGoods,
  getSellBackAddress,
  getSellerWarehouseAddress,
  getCouponCanrefund,
};
